<ng-container *ngIf="dataSource.length; else noDataFound">
    <table mat-table [dataSource]="dataSource">
        <ng-container *ngFor="let colName of tableHeader; let i = index" matColumnDef="{{ displayedColumns[i] }}" >
            <th mat-header-cell *matHeaderCellDef> {{colName}} </th>
            <td mat-cell *matCellDef="let element">{{ element[displayedColumns[i]] }} </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</ng-container>

<ng-template #noDataFound>
    <div id="no-loans-section" class="font-normal py-5">
        <img src="../../../assets/images/empty-folder.svg" alt="No Transactions"/>
        <p class="mt-4">You have no Transactions.</p>
      </div>
</ng-template>

<span class="mt-4 justify-content-center align-items-center" appDottedLoader
      [appShowLoaderUntil]="dataSource"></span>

